import { isLogin as webxIsLogin, login as webxLogin, query, hashQuery } from '@didi/webx-js'
import { trackEvent } from '../../../trackEvent/index.js'

let loginInfo = null
const queryList = Object.assign({}, query(), hashQuery())
export const login = async (data, resolve, reject) => {
  if (loginInfo) {
    resolve(loginInfo)
    return
  }
  if(queryList.token && queryList.token !== '') {
    loginInfo = {
      token: queryList.token || '',
      uid: queryList.uid || ''
    }
    resolve(loginInfo)
  }
  webxIsLogin()
    .then(res => {
      loginInfo = res
      resolve(res)
    })
    .catch(() => {
      trackEvent('userteam_ad_zj_login_pre_bt')
      webxLogin()
        .then(res => {
          loginInfo = res
          trackEvent('userteam_ad_zj_login_success_bt')
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
}
